import React from "react";
import Slider from "react-slick";
import useWindowSize from '../../../hooks/useWindowSize';

const CertificatePerk = ({selectedDomain, name}) => {

  
  const { width } = useWindowSize();

  const settings = {
    dots: false,
    slidesToShow: 2.4,
    rows: 1,
    speed: 300,
    cssEase: "linear",
    arrows: false,
    responsive: [
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 3,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: width <= 360 ? 1.1 : width <= 375 ? 1.2 : width <= 393 ? 1.25 : 1.3,
          infinite: false,
          dots: false,
          arrows: false,
          swipeToSlide: true,
        },
      },
    ],
  };

  // useEffect(()=>{

  // },[lastEnrolled])


  return (
    <div className="w-full mt-3">
      <Slider {...settings}>
        {selectedDomain?.length > 0 &&
          selectedDomain?.map((item, index) => (
            <div className="w-full" key={index}>
              <div className="relative w-[99%] flex h-full flex-col items-center justify-center font-light text-white px-1" key={index}>
                <div className="w-[260px] h-full rounded-xl">
                  <img src="https://assets.learntube.ai/files/PRICING/Group_7719.svg?updatedAt=1684572338778" alt="" className="w-full h-auto rounded-xl"/>
                </div>
                <div className="absolute top-2 md:top-4 right-1 flex w-full flex-col items-center justify-center">
                  <img
                    src='https://assets.learntube.ai/files/AI_Syllabus_generator/learntube.png?updatedAt=1688019617510'
                    className=" w-12 self-center"
                    alt=""
                  ></img>
                  <div className="absolute top-6 self-center text-sm">
                    Certificate of Completion
                  </div>
                  <div className="certificate absolute  top-[42px] text-[8px] italic">
                    This is presented to
                  </div>
                  <div className="text-md absolute top-[50px]">{name}</div>
                  <div className="certificate absolute  top-[72px] text-[8px] italic">
                    for successfully completing
                  </div>
                  <div className="certificate absolute  top-[86px] text-[10px] italic">
                    {item}
                  </div>
                  <img
                    src='https://assets.learntube.ai/files/AI_Syllabus_generator/CEOSign.png?updatedAt=1688019617564'
                    className=" absolute top-[104px] w-14 self-center"
                    alt=""
                  />
                  <div className=" absolute text-[8px] top-[122px]">Shronit Ladhani</div>
                  <div className="font-medium absolute text-[8px] top-[134px]">Founder and CEO ,CAREERNINJA</div>
                  <div className=" absolute text-[6px] top-[146px] ">Id: Dat183643992473</div>
                  <div className=" absolute text-[6px] top-[156px] ">Date: {new Date().toLocaleDateString("en-US")}</div>
                </div>
              </div>
            </div>
          ))}
      </Slider>
    </div>
  );
};

export default CertificatePerk;
